// Generated from src/app/xlogo-parser/grammar/XLogo.g4 by ANTLR 4.7.3-SNAPSHOT


import { ATN } from "antlr4ts/atn/ATN";
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer";
import { CharStream } from "antlr4ts/CharStream";
import { Lexer } from "antlr4ts/Lexer";
import { LexerATNSimulator } from "antlr4ts/atn/LexerATNSimulator";
import { NotNull } from "antlr4ts/Decorators";
import { Override } from "antlr4ts/Decorators";
import { RuleContext } from "antlr4ts/RuleContext";
import { Vocabulary } from "antlr4ts/Vocabulary";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl";

import * as Utils from "antlr4ts/misc/Utils";


export class XLogoLexer extends Lexer {
	public static readonly T__0 = 1;
	public static readonly T__1 = 2;
	public static readonly T__2 = 3;
	public static readonly T__3 = 4;
	public static readonly T__4 = 5;
	public static readonly T__5 = 6;
	public static readonly T__6 = 7;
	public static readonly T__7 = 8;
	public static readonly T__8 = 9;
	public static readonly T__9 = 10;
	public static readonly T__10 = 11;
	public static readonly T__11 = 12;
	public static readonly T__12 = 13;
	public static readonly T__13 = 14;
	public static readonly T__14 = 15;
	public static readonly T__15 = 16;
	public static readonly T__16 = 17;
	public static readonly T__17 = 18;
	public static readonly T__18 = 19;
	public static readonly T__19 = 20;
	public static readonly T__20 = 21;
	public static readonly T__21 = 22;
	public static readonly T__22 = 23;
	public static readonly T__23 = 24;
	public static readonly T__24 = 25;
	public static readonly FuncNameNoArg = 26;
	public static readonly FuncNameOneArg = 27;
	public static readonly FuncNameTwoArg = 28;
	public static readonly Colorname = 29;
	public static readonly Make = 30;
	public static readonly Print = 31;
	public static readonly Sin = 32;
	public static readonly Sqrt = 33;
	public static readonly Tan = 34;
	public static readonly Abs = 35;
	public static readonly Arccos = 36;
	public static readonly Arcsin = 37;
	public static readonly Arctan = 38;
	public static readonly Cos = 39;
	public static readonly Mod = 40;
	public static readonly Random = 41;
	public static readonly Power = 42;
	public static readonly Log = 43;
	public static readonly PiConst = 44;
	public static readonly EConst = 45;
	public static readonly Variable = 46;
	public static readonly VarDecl = 47;
	public static readonly Number = 48;
	public static readonly Boolean = 49;
	public static readonly Identifier = 50;
	public static readonly COMMENT = 51;
	public static readonly EOL = 52;
	public static readonly WS = 53;
	public static readonly ErrorCharacter = 54;

	// tslint:disable:no-trailing-whitespace
	public static readonly channelNames: string[] = [
		"DEFAULT_TOKEN_CHANNEL", "HIDDEN",
	];

	// tslint:disable:no-trailing-whitespace
	public static readonly modeNames: string[] = [
		"DEFAULT_MODE",
	];

	public static readonly ruleNames: string[] = [
		"T__0", "T__1", "T__2", "T__3", "T__4", "T__5", "T__6", "T__7", "T__8", 
		"T__9", "T__10", "T__11", "T__12", "T__13", "T__14", "T__15", "T__16", 
		"T__17", "T__18", "T__19", "T__20", "T__21", "T__22", "T__23", "T__24", 
		"FuncNameNoArg", "FuncNameOneArg", "FuncNameTwoArg", "Colorname", "Make", 
		"Print", "Sin", "Sqrt", "Tan", "Abs", "Arccos", "Arcsin", "Arctan", "Cos", 
		"Mod", "Random", "Power", "Log", "PiConst", "EConst", "Variable", "VarDecl", 
		"Number", "Boolean", "Identifier", "Letter", "Decimal", "Digit", "COMMENT", 
		"EOL", "WS", "ErrorCharacter",
	];

	private static readonly _LITERAL_NAMES: Array<string | undefined> = [
		undefined, "'to'", "'end'", "'['", "']'", "'repeat'", "'if'", "'while'", 
		"'{'", "'}'", "'('", "')'", "'+'", "'-'", "'!'", "'*'", "'/'", "'%'", 
		"'<'", "'<='", "'>'", "'>='", "'='", "'!='", "'&&'", "'||'", undefined, 
		undefined, undefined, undefined, "'make'", undefined, "'sin'", "'sqrt'", 
		"'tan'", "'abs'", undefined, undefined, undefined, "'cos'", "'mod'", undefined, 
		undefined, undefined, "'pi'", "'e'",
	];
	private static readonly _SYMBOLIC_NAMES: Array<string | undefined> = [
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, undefined, undefined, 
		undefined, undefined, undefined, undefined, undefined, "FuncNameNoArg", 
		"FuncNameOneArg", "FuncNameTwoArg", "Colorname", "Make", "Print", "Sin", 
		"Sqrt", "Tan", "Abs", "Arccos", "Arcsin", "Arctan", "Cos", "Mod", "Random", 
		"Power", "Log", "PiConst", "EConst", "Variable", "VarDecl", "Number", 
		"Boolean", "Identifier", "COMMENT", "EOL", "WS", "ErrorCharacter",
	];
	public static readonly VOCABULARY: Vocabulary = new VocabularyImpl(XLogoLexer._LITERAL_NAMES, XLogoLexer._SYMBOLIC_NAMES, []);

	// @Override
	// @NotNull
	public get vocabulary(): Vocabulary {
		return XLogoLexer.VOCABULARY;
	}
	// tslint:enable:no-trailing-whitespace


	constructor(input: CharStream) {
		super(input);
		this._interp = new LexerATNSimulator(XLogoLexer._ATN, this);
	}

	// @Override
	public get grammarFileName(): string { return "XLogo.g4"; }

	// @Override
	public get ruleNames(): string[] { return XLogoLexer.ruleNames; }

	// @Override
	public get serializedATN(): string { return XLogoLexer._serializedATN; }

	// @Override
	public get channelNames(): string[] { return XLogoLexer.channelNames; }

	// @Override
	public get modeNames(): string[] { return XLogoLexer.modeNames; }

	public static readonly _serializedATN: string =
		"\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x028\u01E9\b\x01" +
		"\x04\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06" +
		"\x04\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r" +
		"\t\r\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t" +
		"\x12\x04\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t" +
		"\x17\x04\x18\t\x18\x04\x19\t\x19\x04\x1A\t\x1A\x04\x1B\t\x1B\x04\x1C\t" +
		"\x1C\x04\x1D\t\x1D\x04\x1E\t\x1E\x04\x1F\t\x1F\x04 \t \x04!\t!\x04\"\t" +
		"\"\x04#\t#\x04$\t$\x04%\t%\x04&\t&\x04\'\t\'\x04(\t(\x04)\t)\x04*\t*\x04" +
		"+\t+\x04,\t,\x04-\t-\x04.\t.\x04/\t/\x040\t0\x041\t1\x042\t2\x043\t3\x04" +
		"4\t4\x045\t5\x046\t6\x047\t7\x048\t8\x049\t9\x04:\t:\x03\x02\x03\x02\x03" +
		"\x02\x03\x03\x03\x03\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03" +
		"\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x06\x03\x07\x03\x07\x03" +
		"\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03\b\x03\t\x03\t\x03\n\x03\n\x03\v" +
		"\x03\v\x03\f\x03\f\x03\r\x03\r\x03\x0E\x03\x0E\x03\x0F\x03\x0F\x03\x10" +
		"\x03\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x13\x03\x13\x03\x14\x03\x14" +
		"\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x18" +
		"\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x1A\x03\x1A\x03\x1A\x03\x1B" +
		"\x03\x1B\x05\x1B\xBC\n\x1B\x03\x1C\x03\x1C\x03\x1C\x03\x1C\x03\x1C\x03" +
		"\x1C\x03\x1C\x03\x1C\x03\x1C\x03\x1C\x05\x1C\xC8\n\x1C\x03\x1D\x03\x1D" +
		"\x05\x1D\xCC\n\x1D\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03\x1E\x03" +
		"\x1E\x05\x1E\u012F\n\x1E\x03\x1F\x03\x1F\x03\x1F\x03\x1F\x03\x1F\x03 " +
		"\x03 \x03 \x03 \x03 \x03 \x03 \x05 \u013D\n \x03!\x03!\x03!\x03!\x03\"" +
		"\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03$\x03$\x03$\x03$\x03%" +
		"\x03%\x03%\x03%\x03%\x03%\x03%\x03%\x03%\x03%\x05%\u015A\n%\x03&\x03&" +
		"\x03&\x03&\x03&\x03&\x03&\x03&\x03&\x03&\x05&\u0166\n&\x03\'\x03\'\x03" +
		"\'\x03\'\x03\'\x03\'\x03\'\x03\'\x03\'\x03\'\x05\'\u0172\n\'\x03(\x03" +
		"(\x03(\x03(\x03)\x03)\x03)\x03)\x03*\x03*\x03*\x03*\x03*\x03*\x03*\x03" +
		"*\x03*\x03*\x03*\x03*\x03*\x05*\u0189\n*\x03+\x03+\x03+\x03+\x03+\x03" +
		"+\x03+\x03+\x05+\u0193\n+\x03,\x03,\x03,\x03,\x03,\x03,\x03,\x03,\x05" +
		",\u019D\n,\x03-\x03-\x03-\x03.\x03.\x03/\x03/\x03/\x030\x030\x030\x03" +
		"1\x031\x031\x031\x031\x051\u01AF\n1\x032\x032\x032\x032\x032\x032\x03" +
		"2\x032\x032\x052\u01BA\n2\x033\x033\x033\x033\x073\u01C0\n3\f3\x0E3\u01C3" +
		"\v3\x034\x034\x035\x035\x035\x075\u01CA\n5\f5\x0E5\u01CD\v5\x055\u01CF" +
		"\n5\x036\x036\x037\x037\x077\u01D5\n7\f7\x0E7\u01D8\v7\x037\x037\x038" +
		"\x058\u01DD\n8\x038\x038\x039\x069\u01E2\n9\r9\x0E9\u01E3\x039\x039\x03" +
		":\x03:\x02\x02\x02;\x03\x02\x03\x05\x02\x04\x07\x02\x05\t\x02\x06\v\x02" +
		"\x07\r\x02\b\x0F\x02\t\x11\x02\n\x13\x02\v\x15\x02\f\x17\x02\r\x19\x02" +
		"\x0E\x1B\x02\x0F\x1D\x02\x10\x1F\x02\x11!\x02\x12#\x02\x13%\x02\x14\'" +
		"\x02\x15)\x02\x16+\x02\x17-\x02\x18/\x02\x191\x02\x1A3\x02\x1B5\x02\x1C" +
		"7\x02\x1D9\x02\x1E;\x02\x1F=\x02 ?\x02!A\x02\"C\x02#E\x02$G\x02%I\x02" +
		"&K\x02\'M\x02(O\x02)Q\x02*S\x02+U\x02,W\x02-Y\x02.[\x02/]\x020_\x021a" +
		"\x022c\x023e\x024g\x02\x02i\x02\x02k\x02\x02m\x025o\x026q\x027s\x028\x03" +
		"\x02\x05\x19\x02&&A\\c|\xA5\xA5\xC2\xC2\xC4\xC4\xC6\xC6\xC8\xCD\xD0\xD1" +
		"\xD6\xD6\xD8\xD8\xDB\xDB\xDD\xDE\xE1\xE2\xE4\xE4\xE6\xE6\xE8\xED\xF0\xF1" +
		"\xF6\xF6\xF8\xF8\xFB\xFB\xFD\xFE\u0154\u0155\x04\x02\f\f\x0F\x0F\x04\x02" +
		"\v\v\"\"\x02\u0212\x02\x03\x03\x02\x02\x02\x02\x05\x03\x02\x02\x02\x02" +
		"\x07\x03\x02\x02\x02\x02\t\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r" +
		"\x03\x02\x02\x02\x02\x0F\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13" +
		"\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19" +
		"\x03\x02\x02\x02\x02\x1B\x03\x02\x02\x02\x02\x1D\x03\x02\x02\x02\x02\x1F" +
		"\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02" +
		"\x02\x02\x02\'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02" +
		"\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03" +
		"\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02" +
		"\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02" +
		"A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02" +
		"\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02" +
		"\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03" +
		"\x02\x02\x02\x02W\x03\x02\x02\x02\x02Y\x03\x02\x02\x02\x02[\x03\x02\x02" +
		"\x02\x02]\x03\x02\x02\x02\x02_\x03\x02\x02\x02\x02a\x03\x02\x02\x02\x02" +
		"c\x03\x02\x02\x02\x02e\x03\x02\x02\x02\x02m\x03\x02\x02\x02\x02o\x03\x02" +
		"\x02\x02\x02q\x03\x02\x02\x02\x02s\x03\x02\x02\x02\x03u\x03\x02\x02\x02" +
		"\x05x\x03\x02\x02\x02\x07|\x03\x02\x02\x02\t~\x03\x02\x02\x02\v\x80\x03" +
		"\x02\x02\x02\r\x87\x03\x02\x02\x02\x0F\x8A\x03\x02\x02\x02\x11\x90\x03" +
		"\x02\x02\x02\x13\x92\x03\x02\x02\x02\x15\x94\x03\x02\x02\x02\x17\x96\x03" +
		"\x02\x02\x02\x19\x98\x03\x02\x02\x02\x1B\x9A\x03\x02\x02\x02\x1D\x9C\x03" +
		"\x02\x02\x02\x1F\x9E\x03\x02\x02\x02!\xA0\x03\x02\x02\x02#\xA2\x03\x02" +
		"\x02\x02%\xA4\x03\x02\x02\x02\'\xA6\x03\x02\x02\x02)\xA9\x03\x02\x02\x02" +
		"+\xAB\x03\x02\x02\x02-\xAE\x03\x02\x02\x02/\xB0\x03\x02\x02\x021\xB3\x03" +
		"\x02\x02\x023\xB6\x03\x02\x02\x025\xBB\x03\x02\x02\x027\xC7\x03\x02\x02" +
		"\x029\xCB\x03\x02\x02\x02;\u012E\x03\x02\x02\x02=\u0130\x03\x02\x02\x02" +
		"?\u013C\x03\x02\x02\x02A\u013E\x03\x02\x02\x02C\u0142\x03\x02\x02\x02" +
		"E\u0147\x03\x02\x02\x02G\u014B\x03\x02\x02\x02I\u0159\x03\x02\x02\x02" +
		"K\u0165\x03\x02\x02\x02M\u0171\x03\x02\x02\x02O\u0173\x03\x02\x02\x02" +
		"Q\u0177\x03\x02\x02\x02S\u0188\x03\x02\x02\x02U\u0192\x03\x02\x02\x02" +
		"W\u019C\x03\x02\x02\x02Y\u019E\x03\x02\x02\x02[\u01A1\x03\x02\x02\x02" +
		"]\u01A3\x03\x02\x02\x02_\u01A6\x03\x02\x02\x02a\u01AE\x03\x02\x02\x02" +
		"c\u01B9\x03\x02\x02\x02e\u01BB\x03\x02\x02\x02g\u01C4\x03\x02\x02\x02" +
		"i\u01CE\x03\x02\x02\x02k\u01D0\x03\x02\x02\x02m\u01D2\x03\x02\x02\x02" +
		"o\u01DC\x03\x02\x02\x02q\u01E1\x03\x02\x02\x02s\u01E7\x03\x02\x02\x02" +
		"uv\x07v\x02\x02vw\x07q\x02\x02w\x04\x03\x02\x02\x02xy\x07g\x02\x02yz\x07" +
		"p\x02\x02z{\x07f\x02\x02{\x06\x03\x02\x02\x02|}\x07]\x02\x02}\b\x03\x02" +
		"\x02\x02~\x7F\x07_\x02\x02\x7F\n\x03\x02\x02\x02\x80\x81\x07t\x02\x02" +
		"\x81\x82\x07g\x02\x02\x82\x83\x07r\x02\x02\x83\x84\x07g\x02\x02\x84\x85" +
		"\x07c\x02\x02\x85\x86\x07v\x02\x02\x86\f\x03\x02\x02\x02\x87\x88\x07k" +
		"\x02\x02\x88\x89\x07h\x02\x02\x89\x0E\x03\x02\x02\x02\x8A\x8B\x07y\x02" +
		"\x02\x8B\x8C\x07j\x02\x02\x8C\x8D\x07k\x02\x02\x8D\x8E\x07n\x02\x02\x8E" +
		"\x8F\x07g\x02\x02\x8F\x10\x03\x02\x02\x02\x90\x91\x07}\x02\x02\x91\x12" +
		"\x03\x02\x02\x02\x92\x93\x07\x7F\x02\x02\x93\x14\x03\x02\x02\x02\x94\x95" +
		"\x07*\x02\x02\x95\x16\x03\x02\x02\x02\x96\x97\x07+\x02\x02\x97\x18\x03" +
		"\x02\x02\x02\x98\x99\x07-\x02\x02\x99\x1A\x03\x02\x02\x02\x9A\x9B\x07" +
		"/\x02\x02\x9B\x1C\x03\x02\x02\x02\x9C\x9D\x07#\x02\x02\x9D\x1E\x03\x02" +
		"\x02\x02\x9E\x9F\x07,\x02\x02\x9F \x03\x02\x02\x02\xA0\xA1\x071\x02\x02" +
		"\xA1\"\x03\x02\x02\x02\xA2\xA3\x07\'\x02\x02\xA3$\x03\x02\x02\x02\xA4" +
		"\xA5\x07>\x02\x02\xA5&\x03\x02\x02\x02\xA6\xA7\x07>\x02\x02\xA7\xA8\x07" +
		"?\x02\x02\xA8(\x03\x02\x02\x02\xA9\xAA\x07@\x02\x02\xAA*\x03\x02\x02\x02" +
		"\xAB\xAC\x07@\x02\x02\xAC\xAD\x07?\x02\x02\xAD,\x03\x02\x02\x02\xAE\xAF" +
		"\x07?\x02\x02\xAF.\x03\x02\x02\x02\xB0\xB1\x07#\x02\x02\xB1\xB2\x07?\x02" +
		"\x02\xB20\x03\x02\x02\x02\xB3\xB4\x07(\x02\x02\xB4\xB5\x07(\x02\x02\xB5" +
		"2\x03\x02\x02\x02\xB6\xB7\x07~\x02\x02\xB7\xB8\x07~\x02\x02\xB84\x03\x02" +
		"\x02\x02\xB9\xBC\x05Y-\x02\xBA\xBC\x05[.\x02\xBB\xB9\x03\x02\x02\x02\xBB" +
		"\xBA\x03\x02\x02\x02\xBC6\x03\x02\x02\x02\xBD\xC8\x05A!\x02\xBE\xC8\x05" +
		"E#\x02\xBF\xC8\x05G$\x02\xC0\xC8\x05I%\x02\xC1\xC8\x05K&\x02\xC2\xC8\x05" +
		"M\'\x02\xC3\xC8\x05O(\x02\xC4\xC8\x05C\"\x02\xC5\xC8\x05S*\x02\xC6\xC8" +
		"\x05W,\x02\xC7\xBD\x03\x02\x02\x02\xC7\xBE\x03\x02\x02\x02\xC7\xBF\x03" +
		"\x02\x02\x02\xC7\xC0\x03\x02\x02\x02\xC7\xC1\x03\x02\x02\x02\xC7\xC2\x03" +
		"\x02\x02\x02\xC7\xC3\x03\x02\x02\x02\xC7\xC4\x03\x02\x02\x02\xC7\xC5\x03" +
		"\x02\x02\x02\xC7\xC6\x03\x02\x02\x02\xC88\x03\x02\x02\x02\xC9\xCC\x05" +
		"Q)\x02\xCA\xCC\x05U+\x02\xCB\xC9\x03\x02\x02\x02\xCB\xCA\x03\x02\x02\x02" +
		"\xCC:\x03\x02\x02\x02\xCD\xCE\x07d\x02\x02\xCE\xCF\x07n\x02\x02\xCF\xD0" +
		"\x07c\x02\x02\xD0\xD1\x07e\x02\x02\xD1\u012F\x07m\x02\x02\xD2\xD3\x07" +
		"t\x02\x02\xD3\xD4\x07g\x02\x02\xD4\u012F\x07f\x02\x02\xD5\xD6\x07i\x02" +
		"\x02\xD6\xD7\x07t\x02\x02\xD7\xD8\x07g\x02\x02\xD8\xD9\x07g\x02\x02\xD9" +
		"\u012F\x07p\x02\x02\xDA\xDB\x07{\x02\x02\xDB\xDC\x07g\x02\x02\xDC\xDD" +
		"\x07n\x02\x02\xDD\xDE\x07n\x02\x02\xDE\xDF\x07q\x02\x02\xDF\u012F\x07" +
		"y\x02\x02\xE0\xE1\x07d\x02\x02\xE1\xE2\x07n\x02\x02\xE2\xE3\x07w\x02\x02" +
		"\xE3\u012F\x07g\x02\x02\xE4\xE5\x07o\x02\x02\xE5\xE6\x07c\x02\x02\xE6" +
		"\xE7\x07i\x02\x02\xE7\xE8\x07g\x02\x02\xE8\xE9\x07p\x02\x02\xE9\xEA\x07" +
		"v\x02\x02\xEA\u012F\x07c\x02\x02\xEB\xEC\x07e\x02\x02\xEC\xED\x07{\x02" +
		"\x02\xED\xEE\x07c\x02\x02\xEE\u012F\x07p\x02\x02\xEF\xF0\x07y\x02\x02" +
		"\xF0\xF1\x07j\x02\x02\xF1\xF2\x07k\x02\x02\xF2\xF3\x07v\x02\x02\xF3\u012F" +
		"\x07g\x02\x02\xF4\xF5\x07i\x02\x02\xF5\xF6\x07t\x02\x02\xF6\xF7\x07c\x02" +
		"\x02\xF7\u012F\x07{\x02\x02\xF8\xF9\x07n\x02\x02\xF9\xFA\x07k\x02\x02" +
		"\xFA\xFB\x07i\x02\x02\xFB\xFC\x07j\x02\x02\xFC\xFD\x07v\x02\x02\xFD\xFE" +
		"\x07i\x02\x02\xFE\xFF\x07t\x02\x02\xFF\u0100\x07c\x02\x02\u0100\u012F" +
		"\x07{\x02\x02\u0101\u0102\x07f\x02\x02\u0102\u0103\x07c\x02\x02\u0103" +
		"\u0104\x07t\x02\x02\u0104\u0105\x07m\x02\x02\u0105\u0106\x07t\x02\x02" +
		"\u0106\u0107\x07g\x02\x02\u0107\u012F\x07f\x02\x02\u0108\u0109\x07f\x02" +
		"\x02\u0109\u010A\x07c\x02\x02\u010A\u010B\x07t\x02\x02\u010B\u010C\x07" +
		"m\x02\x02\u010C\u010D\x07i\x02\x02\u010D\u010E\x07t\x02\x02\u010E\u010F" +
		"\x07g\x02\x02\u010F\u0110\x07g\x02\x02\u0110\u012F\x07p\x02\x02\u0111" +
		"\u0112\x07f\x02\x02\u0112\u0113\x07c\x02\x02\u0113\u0114\x07t\x02\x02" +
		"\u0114\u0115\x07m\x02\x02\u0115\u0116\x07d\x02\x02\u0116\u0117\x07n\x02" +
		"\x02\u0117\u0118\x07w\x02\x02\u0118\u012F\x07g\x02\x02\u0119\u011A\x07" +
		"q\x02\x02\u011A\u011B\x07t\x02\x02\u011B\u011C\x07c\x02\x02\u011C\u011D" +
		"\x07p\x02\x02\u011D\u011E\x07i\x02\x02\u011E\u012F\x07g\x02\x02\u011F" +
		"\u0120\x07r\x02\x02\u0120\u0121\x07k\x02\x02\u0121\u0122\x07p\x02\x02" +
		"\u0122\u012F\x07m\x02\x02\u0123\u0124\x07r\x02\x02\u0124\u0125\x07w\x02" +
		"\x02\u0125\u0126\x07t\x02\x02\u0126\u0127\x07r\x02\x02\u0127\u0128\x07" +
		"n\x02\x02\u0128\u012F\x07g\x02\x02\u0129\u012A\x07d\x02\x02\u012A\u012B" +
		"\x07t\x02\x02\u012B\u012C\x07q\x02\x02\u012C\u012D\x07y\x02\x02\u012D" +
		"\u012F\x07p\x02\x02\u012E\xCD\x03\x02\x02\x02\u012E\xD2\x03\x02\x02\x02" +
		"\u012E\xD5\x03\x02\x02\x02\u012E\xDA\x03\x02\x02\x02\u012E\xE0\x03\x02" +
		"\x02\x02\u012E\xE4\x03\x02\x02\x02\u012E\xEB\x03\x02\x02\x02\u012E\xEF" +
		"\x03\x02\x02\x02\u012E\xF4\x03\x02\x02\x02\u012E\xF8\x03\x02\x02\x02\u012E" +
		"\u0101\x03\x02\x02\x02\u012E\u0108\x03\x02\x02\x02\u012E\u0111\x03\x02" +
		"\x02\x02\u012E\u0119\x03\x02\x02\x02\u012E\u011F\x03\x02\x02\x02\u012E" +
		"\u0123\x03\x02\x02\x02\u012E\u0129\x03\x02\x02\x02\u012F<\x03\x02\x02" +
		"\x02\u0130\u0131\x07o\x02\x02\u0131\u0132\x07c\x02\x02\u0132\u0133\x07" +
		"m\x02\x02\u0133\u0134\x07g\x02\x02\u0134>\x03\x02\x02\x02\u0135\u0136" +
		"\x07r\x02\x02\u0136\u0137\x07t\x02\x02\u0137\u0138\x07k\x02\x02\u0138" +
		"\u0139\x07p\x02\x02\u0139\u013D\x07v\x02\x02\u013A\u013B\x07r\x02\x02" +
		"\u013B\u013D\x07t\x02\x02\u013C\u0135\x03\x02\x02\x02\u013C\u013A\x03" +
		"\x02\x02\x02\u013D@\x03\x02\x02\x02\u013E\u013F\x07u\x02\x02\u013F\u0140" +
		"\x07k\x02\x02\u0140\u0141\x07p\x02\x02\u0141B\x03\x02\x02\x02\u0142\u0143" +
		"\x07u\x02\x02\u0143\u0144\x07s\x02\x02\u0144\u0145\x07t\x02\x02\u0145" +
		"\u0146\x07v\x02\x02\u0146D\x03\x02\x02\x02\u0147\u0148\x07v\x02\x02\u0148" +
		"\u0149\x07c\x02\x02\u0149\u014A\x07p\x02\x02\u014AF\x03\x02\x02\x02\u014B" +
		"\u014C\x07c\x02\x02\u014C\u014D\x07d\x02\x02\u014D\u014E\x07u\x02\x02" +
		"\u014EH\x03\x02\x02\x02\u014F\u0150\x07c\x02\x02\u0150\u0151\x07t\x02" +
		"\x02\u0151\u0152\x07e\x02\x02\u0152\u0153\x07e\x02\x02\u0153\u0154\x07" +
		"q\x02\x02\u0154\u015A\x07u\x02\x02\u0155\u0156\x07c\x02\x02\u0156\u0157" +
		"\x07e\x02\x02\u0157\u0158\x07q\x02\x02\u0158\u015A\x07u\x02\x02\u0159" +
		"\u014F\x03\x02\x02\x02\u0159\u0155\x03\x02\x02\x02\u015AJ\x03\x02\x02" +
		"\x02\u015B\u015C\x07c\x02\x02\u015C\u015D\x07t\x02\x02\u015D\u015E\x07" +
		"e\x02\x02\u015E\u015F\x07u\x02\x02\u015F\u0160\x07k\x02\x02\u0160\u0166" +
		"\x07p\x02\x02\u0161\u0162\x07c\x02\x02\u0162\u0163\x07u\x02\x02\u0163" +
		"\u0164\x07k\x02\x02\u0164\u0166\x07p\x02\x02\u0165\u015B\x03\x02\x02\x02" +
		"\u0165\u0161\x03\x02\x02\x02\u0166L\x03\x02\x02\x02\u0167\u0168\x07c\x02" +
		"\x02\u0168\u0169\x07t\x02\x02\u0169\u016A\x07e\x02\x02\u016A\u016B\x07" +
		"v\x02\x02\u016B\u016C\x07c\x02\x02\u016C\u0172\x07p\x02\x02\u016D\u016E" +
		"\x07c\x02\x02\u016E\u016F\x07v\x02\x02\u016F\u0170\x07c\x02\x02\u0170" +
		"\u0172\x07p\x02\x02\u0171\u0167\x03\x02\x02\x02\u0171\u016D\x03\x02\x02" +
		"\x02\u0172N\x03\x02\x02\x02\u0173\u0174\x07e\x02\x02\u0174\u0175\x07q" +
		"\x02\x02\u0175\u0176\x07u\x02\x02\u0176P\x03\x02\x02\x02\u0177\u0178\x07" +
		"o\x02\x02\u0178\u0179\x07q\x02\x02\u0179\u017A\x07f\x02\x02\u017AR\x03" +
		"\x02\x02\x02\u017B\u017C\x07t\x02\x02\u017C\u017D\x07c\x02\x02\u017D\u017E" +
		"\x07p\x02\x02\u017E\u017F\x07f\x02\x02\u017F\u0180\x07q\x02\x02\u0180" +
		"\u0189\x07o\x02\x02\u0181\u0182\x07t\x02\x02\u0182\u0183\x07c\x02\x02" +
		"\u0183\u0184\x07p\x02\x02\u0184\u0189\x07f\x02\x02\u0185\u0186\x07t\x02" +
		"\x02\u0186\u0187\x07p\x02\x02\u0187\u0189\x07f\x02\x02\u0188\u017B\x03" +
		"\x02\x02\x02\u0188\u0181\x03\x02\x02\x02\u0188\u0185\x03\x02\x02\x02\u0189" +
		"T\x03\x02\x02\x02\u018A\u018B\x07r\x02\x02\u018B\u018C\x07q\x02\x02\u018C" +
		"\u018D\x07y\x02\x02\u018D\u018E\x07g\x02\x02\u018E\u0193\x07t\x02\x02" +
		"\u018F\u0190\x07r\x02\x02\u0190\u0191\x07q\x02\x02\u0191\u0193\x07y\x02" +
		"\x02\u0192\u018A\x03\x02\x02\x02\u0192\u018F\x03\x02\x02\x02\u0193V\x03" +
		"\x02\x02\x02\u0194\u0195\x07n\x02\x02\u0195\u0196\x07q\x02\x02\u0196\u019D" +
		"\x07i\x02\x02\u0197\u0198\x07n\x02\x02\u0198\u0199\x07q\x02\x02\u0199" +
		"\u019A\x07i\x02\x02\u019A\u019B\x073\x02\x02\u019B\u019D\x072\x02\x02" +
		"\u019C\u0194\x03\x02\x02\x02\u019C\u0197\x03\x02\x02\x02\u019DX\x03\x02" +
		"\x02\x02\u019E\u019F\x07r\x02\x02\u019F\u01A0\x07k\x02\x02\u01A0Z\x03" +
		"\x02\x02\x02\u01A1\u01A2\x07g\x02\x02\u01A2\\\x03\x02\x02\x02\u01A3\u01A4" +
		"\x07<\x02\x02\u01A4\u01A5\x05e3\x02\u01A5^\x03\x02\x02\x02\u01A6\u01A7" +
		"\x07$\x02\x02\u01A7\u01A8\x05e3\x02\u01A8`\x03\x02\x02\x02\u01A9\u01AF" +
		"\x05i5\x02\u01AA\u01AB\x05i5\x02\u01AB\u01AC\x070\x02\x02\u01AC\u01AD" +
		"\x05i5\x02\u01AD\u01AF\x03\x02\x02\x02\u01AE\u01A9\x03\x02\x02\x02\u01AE" +
		"\u01AA\x03\x02\x02\x02\u01AFb\x03\x02\x02\x02\u01B0\u01B1\x07h\x02\x02" +
		"\u01B1\u01B2\x07c\x02\x02\u01B2\u01B3\x07n\x02\x02\u01B3\u01B4\x07u\x02" +
		"\x02\u01B4\u01BA\x07g\x02\x02\u01B5\u01B6\x07v\x02\x02\u01B6\u01B7\x07" +
		"t\x02\x02\u01B7\u01B8\x07w\x02\x02\u01B8\u01BA\x07g\x02\x02\u01B9\u01B0" +
		"\x03\x02\x02\x02\u01B9\u01B5\x03\x02\x02\x02\u01BAd\x03\x02\x02\x02\u01BB" +
		"\u01C1\x05g4\x02\u01BC\u01C0\x05g4\x02\u01BD\u01C0\x05k6\x02\u01BE\u01C0" +
		"\x07a\x02\x02\u01BF\u01BC\x03\x02\x02\x02\u01BF\u01BD\x03\x02\x02\x02" +
		"\u01BF\u01BE\x03\x02\x02\x02\u01C0\u01C3\x03\x02\x02\x02\u01C1\u01BF\x03" +
		"\x02\x02\x02\u01C1\u01C2\x03\x02\x02\x02\u01C2f\x03\x02\x02\x02\u01C3" +
		"\u01C1\x03\x02\x02\x02\u01C4\u01C5\t\x02\x02\x02\u01C5h\x03\x02\x02\x02" +
		"\u01C6\u01CF\x072\x02\x02\u01C7\u01CB\x042;\x02\u01C8\u01CA\x05k6\x02" +
		"\u01C9\u01C8\x03\x02\x02\x02\u01CA\u01CD\x03\x02\x02\x02\u01CB\u01C9\x03" +
		"\x02\x02\x02\u01CB\u01CC\x03\x02\x02\x02\u01CC\u01CF\x03\x02\x02\x02\u01CD" +
		"\u01CB\x03\x02\x02\x02\u01CE\u01C6\x03\x02\x02\x02\u01CE\u01C7\x03\x02" +
		"\x02\x02\u01CFj\x03\x02\x02\x02\u01D0\u01D1\x042;\x02\u01D1l\x03\x02\x02" +
		"\x02\u01D2\u01D6\x07%\x02\x02\u01D3\u01D5\n\x03\x02\x02\u01D4\u01D3\x03" +
		"\x02\x02\x02\u01D5\u01D8\x03\x02\x02\x02\u01D6\u01D4\x03\x02\x02\x02\u01D6" +
		"\u01D7\x03\x02\x02\x02\u01D7\u01D9\x03\x02\x02\x02\u01D8\u01D6\x03\x02" +
		"\x02\x02\u01D9\u01DA\b7\x02\x02\u01DAn\x03\x02\x02\x02\u01DB\u01DD\x07" +
		"\x0F\x02\x02\u01DC\u01DB\x03\x02\x02\x02\u01DC\u01DD\x03\x02\x02\x02\u01DD" +
		"\u01DE\x03\x02\x02\x02\u01DE\u01DF\x07\f\x02\x02\u01DFp\x03\x02\x02\x02" +
		"\u01E0\u01E2\t\x04\x02\x02\u01E1\u01E0\x03\x02\x02\x02\u01E2\u01E3\x03" +
		"\x02\x02\x02\u01E3\u01E1\x03\x02\x02\x02\u01E3\u01E4\x03\x02\x02\x02\u01E4" +
		"\u01E5\x03\x02\x02\x02\u01E5\u01E6\b9\x02\x02\u01E6r\x03\x02\x02\x02\u01E7" +
		"\u01E8\v\x02\x02\x02\u01E8t\x03\x02\x02\x02\x17\x02\xBB\xC7\xCB\u012E" +
		"\u013C\u0159\u0165\u0171\u0188\u0192\u019C\u01AE\u01B9\u01BF\u01C1\u01CB" +
		"\u01CE\u01D6\u01DC\u01E3\x03\b\x02\x02";
	public static __ATN: ATN;
	public static get _ATN(): ATN {
		if (!XLogoLexer.__ATN) {
			XLogoLexer.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(XLogoLexer._serializedATN));
		}

		return XLogoLexer.__ATN;
	}

}




// WEBPACK FOOTER //
// ./src/app/xlogo-parser/parser/XLogoLexer.ts